export const AI_REQUEST = 'ai/AI_REQUEST'
export const AI_REQUEST_STARTED = 'ai/AI_REQUEST_STARTED'
export const AI_REQUEST_SUCCESS = 'ai/AI_REQUEST_SUCCESS'
export const AI_REQUEST_FAILED = 'ai/AI_REQUEST_FAILED'

export const FETCH_AI_JOB_RESULT = 'ai/FETCH_AI_JOB_RESULT'
export const FETCH_AI_JOB_RESULT_STARTED = 'ai/FETCH_AI_JOB_RESULT_STARTED'
export const FETCH_AI_JOB_RESULT_SUCCESS = 'ai/FETCH_AI_JOB_RESULT_SUCCESS'
export const FETCH_AI_JOB_RESULT_FAILED = 'ai/FETCH_AI_JOB_RESULT_FAILED'

export const FETCH_AI_JOB_INSTANT_REPLY_RESULT =
  'ai/FETCH_AI_JOB_INSTANT_REPLY_RESULT'
export const FETCH_AI_JOB_INSTANT_REPLY_RESULT_STARTED =
  'ai/FETCH_AI_JOB_INSTANT_REPLY_RESULT_STARTED'
export const FETCH_AI_JOB_INSTANT_REPLY_RESULT_FAILED =
  'ai/FETCH_AI_JOB_INSTANT_REPLY_RESULT_FAILED'
export const FETCH_AI_JOB_INSTANT_REPLY_RESULT_END =
  'ai/FETCH_AI_JOB_INSTANT_REPLY_RESULT_END'
export const FETCH_AI_JOB_INSTANT_REPLY_RESULT_CANCEL =
  'ai/FETCH_AI_JOB_INSTANT_REPLY_RESULT_CANCEL'
export const FETCH_AI_JOB_INSTANT_REPLY_RESULT_HIDE =
  'ai/FETCH_AI_JOB_INSTANT_REPLY_RESULT_HIDE'
export const FETCH_AI_JOB_INSTANT_REPLY_RESULT_CLEAR =
  'ai/FETCH_AI_JOB_INSTANT_REPLY_RESULT_CLEAR'

export const FETCH_AI_JOB_CONVERSATION_RESULT =
  'ai/FETCH_AI_JOB_CONVERSATION_RESULT'
export const FETCH_AI_JOB_CONVERSATION_RESULT_STARTED =
  'ai/FETCH_AI_JOB_CONVERSATION_RESULT_STARTED'
export const FETCH_AI_JOB_CONVERSATION_RESULT_FAILED =
  'ai/FETCH_AI_JOB_CONVERSATION_RESULT_FAILED'
export const FETCH_AI_JOB_CONVERSATION_RESULT_END =
  'ai/FETCH_AI_JOB_CONVERSATION_RESULT_END'
export const FETCH_AI_JOB_CONVERSATION_RESULT_CLEAR =
  'ai/FETCH_AI_JOB_CONVERSATION_RESULT_CLEAR'
export const FETCH_AI_JOB_CONVERSATION_RESULT_INITIALIZE =
  'ai/FETCH_AI_JOB_CONVERSATION_RESULT_INITIALIZE'

export const FETCH_AI_JOB_COMPOSER_RESULT = 'ai/FETCH_AI_JOB_COMPOSER_RESULT'
export const FETCH_AI_JOB_COMPOSER_RESULT_STARTED =
  'ai/FETCH_AI_JOB_COMPOSER_RESULT_STARTED'
export const FETCH_AI_JOB_COMPOSER_RESULT_FAILED =
  'ai/FETCH_AI_JOB_COMPOSER_RESULT_FAILED'
export const FETCH_AI_JOB_COMPOSER_RESULT_END =
  'ai/FETCH_AI_JOB_COMPOSER_RESULT_END'
export const FETCH_AI_JOB_COMPOSER_RESULT_CLEAR =
  'ai/FETCH_AI_JOB_COMPOSER_RESULT_CLEAR'
export const FETCH_AI_JOB_COMPOSER_RESULT_INITIALIZE =
  'ai/FETCH_AI_JOB_COMPOSER_RESULT_INITIALIZE'

export const INSTANT_REPLY_TYPE = 'instantReply'
export const CONVERSATION_TYPE = 'conversation'
export const COMPOSER_TYPE = 'composer'

export const TEXT_REFINER_SERVICE = 'groove-text-refiner'

export const INSTANT_REPLY_CAST_ACTION = 'cast_instant_reply'
export const SUMMARY_ACTION = 'summary'
export const SPELLING_ACTION = 'spelling'
export const SHORTEN_ACTION = 'shorten'
export const LENGTHEN_ACTION = 'lengthen'
export const FORMAL_ACTION = 'formal'
export const CASUAL_ACTION = 'casual'
export const CLARIFY_ACTION = 'clarify'

export const ACTION_RPC_METHOD_MAP = {
  [INSTANT_REPLY_CAST_ACTION]: 'instant_reply.cast_from_text',
  [SUMMARY_ACTION]: 'summary.cast_from_messages',
  [SPELLING_ACTION]: 'rewrite.correct_grammar',
  [SHORTEN_ACTION]: 'rewrite.modify_length',
  [LENGTHEN_ACTION]: 'rewrite.modify_length',
  [FORMAL_ACTION]: 'rewrite.modify_tone',
  [CASUAL_ACTION]: 'rewrite.modify_tone',
  [CLARIFY_ACTION]: 'rewrite.clarify',
}

export const REQUEST_TYPES = {
  [INSTANT_REPLY_CAST_ACTION]: INSTANT_REPLY_TYPE,
  [SUMMARY_ACTION]: CONVERSATION_TYPE,
  [SPELLING_ACTION]: COMPOSER_TYPE,
  [SHORTEN_ACTION]: COMPOSER_TYPE,
  [LENGTHEN_ACTION]: COMPOSER_TYPE,
  [FORMAL_ACTION]: COMPOSER_TYPE,
  [CASUAL_ACTION]: COMPOSER_TYPE,
  [CLARIFY_ACTION]: COMPOSER_TYPE,
}
